import { CalendarEventRef } from '@griply/types';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { getExternalCalendarEvent } from 'shared/services/backend-api';

import { queryKey } from './use-external-calendar-event-query';

const STALE_TIME_MS = 60 * 1000;

// backstop for a list flag that a backend deployed before it shipped omits entirely
export const useResolveExternalEventRecurrence = () => {
  const client = useQueryClient();

  return useCallback(
    async (eventRef: CalendarEventRef): Promise<boolean> => {
      try {
        const details = await client.fetchQuery({
          queryKey: [
            queryKey,
            eventRef.connectionId,
            eventRef.calendarId,
            eventRef.eventId,
          ],
          queryFn: async () => getExternalCalendarEvent(eventRef),
          staleTime: STALE_TIME_MS,
        });
        return !!details?.isRecurring;
      } catch {
        // Unreachable detail: fall through as non-recurring. Single is the conservative
        // answer — it touches one occurrence instead of rewriting a whole series.
        return false;
      }
    },
    [client],
  );
};
